/**
 * @flow
 * @relayHash 3ecf45bd8472258f52b5e81d2d41b7c7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddGiftcardToCartInput = {|
  productId: string
|};
export type AddGiftcardToCartMutationVariables = {|
  input: AddGiftcardToCartInput
|};
export type AddGiftcardToCartMutationResponse = {|
  +addGiftcardToCart: ?{|
    +cart: ?{|
      +id: string,
      +lineItems: ?$ReadOnlyArray<?{|
        +id: string,
        +product: ?{|
          +id: string,
          +price: ?any,
          +type: ?string,
          +label: ?string,
        |},
      |}>,
      +totalPrice: ?any,
    |}
  |}
|};
export type AddGiftcardToCartMutation = {|
  variables: AddGiftcardToCartMutationVariables,
  response: AddGiftcardToCartMutationResponse,
|};
*/


/*
mutation AddGiftcardToCartMutation(
  $input: AddGiftcardToCartInput!
) {
  addGiftcardToCart(input: $input) {
    cart {
      id
      lineItems {
        id
        product {
          id
          price
          type
          label
        }
      }
      totalPrice
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddGiftcardToCartInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addGiftcardToCart",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddGiftcardToCartPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "cart",
        "storageKey": null,
        "args": null,
        "concreteType": "Cart",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "lineItems",
            "storageKey": null,
            "args": null,
            "concreteType": "LineItem",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "product",
                "storageKey": null,
                "args": null,
                "concreteType": "Product",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "price",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "type",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "label",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalPrice",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddGiftcardToCartMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddGiftcardToCartMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddGiftcardToCartMutation",
    "id": null,
    "text": "mutation AddGiftcardToCartMutation(\n  $input: AddGiftcardToCartInput!\n) {\n  addGiftcardToCart(input: $input) {\n    cart {\n      id\n      lineItems {\n        id\n        product {\n          id\n          price\n          type\n          label\n        }\n      }\n      totalPrice\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b02b776e45fd69a3489992b605abf31b';

module.exports = node;
